

























































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { listRoles } from '@/services/role/roleService';
import { commonModule } from '@/store/modules/CommonStore';
import { LoginInfo } from '@/types/type';
import { UserDetail } from '@/utils/UserDetail';
import { UserRoleTypes } from '@/utils/UserManagementUtils';

@Component
export default class UserDetailDialog extends Vue {
  private UserRoleTypes = UserRoleTypes;
  private dialog: boolean = true;
  private availableRoles: any[] = [];
  private selectedRoleId: string | null | undefined = null;
  private loginInfo!: LoginInfo;

  @Prop()
  private user!: UserDetail;

  private loginName!: string;

  public async created(): Promise<void> {
    // ログイン情報を取得
    this.loginInfo = commonModule.loginInfo;

    this.loginName = this.user.loginName;
    this.selectedRoleId = this.user.roleId || null;

    try {
      // 利用可能なロールの一覧を取得（ユーザーのテナント・ランドスケープを使用）
      this.availableRoles = await listRoles(
        this.loginInfo.tenant,
        this.loginInfo.landscape
      );
    } catch (error) {
      // エラーハンドリング
      this.availableRoles = [];
    }
  }

  @Emit('pressed-delete-user-data-btn')
  private emitDeleteUserDataBtnAction() {
    return true;
  }

  @Emit('pressed-close-btn')
  private emitCloseBtnAction() {
    return true;
  }

  @Emit('pressed-save-btn')
  private emitSaveBtnAction() {
    this.user.roleId = this.selectedRoleId || undefined;
    return this.user;
  }
}
